import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});

export default function Country_Card({data}) {
  const classes = useStyles();
  const bull = <span className={classes.bullet}>•</span>;

  return (
    <Card className={classes.root} variant="outlined">
      <CardContent>
        <Typography className={classes.pos} variant="h6" component="h2" align="center">
          {data.name}
        </Typography>
        <Typography className={classes.pos} >
          Population: {data.population}
        </Typography>
        <Typography className={classes.pos}>
          Number of Vaccinations: {data.total_doses_admin}
        </Typography>
        <Typography className={classes.pos}>
          Percent of Population Vaccinated: {data.total_doses_admin * 100.0 / data.population}%
        </Typography>
      </CardContent>
      <CardActions>
        <Button size="small" href={"GlobalVacc/" + data.country_id}>Learn More </Button>
      </CardActions>
    </Card>
  );
}